export default __webpack_public_path__ + "static/media/693.91628d0a.png";